import React, { useState, useEffect } from 'react';
import {
	Cell,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
	LineChart,
	Line,
	LabelList,
	AreaChart,
	Area,
} from 'recharts';
import TableLoading from '../../../components/TableLoading';
import { request } from '../../../services/utilities';
import { analyticsAPI } from '../../../services/constants';
import AntenatalOverview from '../AntenatalOverview';
import ImmunizationOverview from '../ImmunizationOverview';
import moment from 'moment';
import SlidingPane from '../../../components/SlidingPane';
import { Card, Col, Row, Statistic } from 'antd';
import AnalysisBystaff from '../../../components/Modals/frontDesk/staffAnalyticsmodal';
import { TimeRangeDropdownAlt3 as TimeRangeDropdown } from '../../../components/TimeRangeDropdownAlt3';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ff6e54', '#ffc0cb', '#faad14'];

// const TimeRangeDropdown = ({ value, onChange, chartId }) => {
// 	return (
// 		<select
// 			value={value}
// 			onChange={e => onChange(e.target.value, chartId)}
// 			className="form-control form-control-sm rounded"
// 			style={{ width: '140px', marginBottom: '10px', borderRadius: '50px' }}
// 		>
// 			<option value="today">Today</option>
// 			<option value="pastWeek">Past Week</option>
// 			<option value="past30Days">Past 30 Days</option>
// 			<option value="pastYear">Past Year</option>
// 			<option value="allTime">All Time</option>
// 		</select>
// 	);
// };

// const TimeRangeDropdown = ({ value, onChange, chartId }) => {
// 	return (
// 		<select
// 			value={value}
// 			onChange={e => onChange(e.target.value, chartId)}
// 			className="form-control form-control-sm rounded"
// 			style={{ width: '160px', marginBottom: '10px', borderRadius: '50px' }}
// 		>
// 			<option value="today">Today</option>
// 			<option value="pastWeek">Past Week</option>
// 			<option value="past30Days">Past 30 Days</option>
// 			<option value="lastMonth">Last Month</option>
// 			<option value="pastQuarter">Past Quarter</option>
// 			<option value="pastSixMonths">Past Six Months</option>
// 			<option value="lastYear">Last Year</option>
// 			<option value="pastYear">Past Year</option>
// 			<option value="pastThreeYears">Past Three Years</option>
// 			<option value="allTime">All Time</option>
// 		</select>
// 	);
// };

const DoctorOverviewModal = ({ selectedStaff }) => {
	// Time ranges for each chart
	const [timeRanges, setTimeRanges] = useState({
		topDoctorsByConsultation: 'past30Days',
		overviewMetrics: 'past30Days',
		consultationTrends: 'past30Days',
		topBottomDoctors: 'past30Days',
		topBottomProcedures: 'past30Days',
		procedureTrends: 'past30Days',
		departmentLoads: 'past30Days',
		specialtyLoads: 'past30Days',
		doctorEfficiency: 'past30Days',
		referralPatterns: 'past30Days',
		patientWaitTimes: 'past30Days',
		doctorAdmission: 'past30Days',
		admissionTrends: 'past30Days',
		dischargeTrends: 'past30Days',
		doctorsEncounter: 'past30Days',
		metrics: 'past30Days',
		dischargeCount: 'past30Days',
		admissionCount: 'past30Days',
		investigationCount: 'past30Days',
		encountersCount: 'past30Days',
		investigationAdmission: 'past30Days',
		investigationByDoctor: 'past30Days',
		investigationByHour: 'past30Days',
	});

	// const mapTimeRangeToApiFilter = range => {
	// 	switch (range) {
	// 		case 'today':
	// 			return 'today';
	// 		case 'pastWeek':
	// 			return 'past-week';
	// 		case 'past30Days':
	// 			return 'past-month';
	// 		case 'pastYear':
	// 			return 'past-year';
	// 		case 'allTime':
	// 			return 'all-time';
	// 		default:
	// 			return 'past-month';
	// 	}
	// };

	// Loading states

	const mapTimeRangeToApiFilter = range => {
		switch (range) {
			case 'today':
				return 'today';
			case 'pastWeek':
				return 'past-week';
			case 'past30Days':
				return 'past-month';
			case 'lastMonth':
				return 'last-month';
			case 'pastQuarter':
				return 'past-quarter';
			case 'pastSixMonths':
				return 'past-six-months';
			case 'pastYear':
				return 'past-year';
			case 'lasYear':
				return 'last-year';
			case 'pastThreeYears':
				return 'past-three-years';
			case 'allTime':
				return 'all-time';
			default:
				return 'past-month';
		}
	};

	const [loadingStates, setLoadingStates] = useState({
		overviewMetrics: false,
		consultationTrends: false,
		topBottomDoctors: false,
		topBottomProcedures: false,
		procedureTrends: false,
		departmentLoads: false,
		specialtyLoads: false,
		doctorEfficiency: false,
		referralPatterns: false,
		patientWaitTimes: false,
		doctorAdmission: false,
		admissionTrends: false,
		dischargeTrends: false,
		doctorsEncounter: false,
		dischargeCount: false,
		admissionCount: false,
		investigationCount: false,
		encountersCount: false,
		investigationAdmission: false,
		investigationByDoctor: false,
		investigationByHour: false,
	});

	// Data states
	const [consultationTrends, setConsultationTrends] = useState([]);
	const [topDoctors, setTopDoctors] = useState([]);
	const [bottomDoctors, setBottomDoctors] = useState([]);

	const [topBottomProcedures, setTopBottomProcedures] = useState([]);
	const [procedureTrends, setProcedureTrends] = useState([]);
	const [departmentLoads, setDepartmentLoads] = useState([]);

	const [staffRankingTop, setStaffRankingTop] = useState([]);
	const [staffRankingBottom, setStaffRankingBottom] = useState([]);

	const [doctorAdmission, setDoctorAdmission] = useState([]);
	const [admissionTrends, setAdmissionTrends] = useState([]);
	const [dischargeTrends, setDisChargeTrends] = useState([]);
	// const [encountersCount, setEncountersCount] = useState(null);
	const [doctorsEncounter, setDoctorsEncounter] = useState([]);
	const [dischargeCount, setDischargeCount] = useState(null);
	const [admissionCount, setAdmissionCount] = useState(null);
	const [investigationCount, setInvestigationCount] = useState(null);
	const [encountersCount, setEncountersCount] = useState(null);
	const [activeTab, setActiveTab] = useState('doctor');
	const [modal, setModal] = useState(false);

	const [investigationAdmission, setInvestigationAdmission] = useState(false);
	const [investigationByDoctor, setInvestigationByDoctor] = useState(false);
	const [investigationByHour, setInvestigationByHour] = useState(false);

	// Fetch functions API

	const fetchInvestigationByDoctor = async range => {
		setLoadingStates(prev => ({ ...prev, investigationByDoctor: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/investigation-by-doctor?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = Object.entries(res?.result)
				?.sort(() => Math.random() - 0.5)
				?.map(([name, count]) => ({
					name,
					count,
				}));

			setInvestigationByDoctor(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationByDoctor: false }));
		}
	};

	const fetchInvestigationByHour = async range => {
		setLoadingStates(prev => ({ ...prev, investigationByHour: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/investigation-per-hour?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result
				?.sort(() => Math.random() - 0.5)
				?.map(item => ({
					name: `${item?.hour}:00` || item?.date || item?.year || item?.month || 'Unknown',
					count: item?.count || 0,
				}));

			setInvestigationByHour(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationByHour: false }));
		}
	};

	const investigationByAdmission = async range => {
		setLoadingStates(prev => ({ ...prev, investigationAdmission: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/investigation-admission?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result?.map(item => ({
				name: item?.date || item?.year || item?.month || 'Unknown',
				count: item?.count || 0,
			}));
			setInvestigationAdmission(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationAdmission: false }));
		}
	};

	const fetchDoctorAdmission = async range => {
		setLoadingStates(prev => ({ ...prev, doctorAdmission: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`${analyticsAPI}/doctor-admission?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = Object.entries(res?.result)
				?.sort(() => Math.random() - 0.5)
				?.map(([name, count]) => ({
					name,
					count,
				}))
				.slice(0, 30);

			setDoctorAdmission(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, doctorAdmission: false }));
		}
	};

	const fetchAdmissionTrends = async range => {
		setLoadingStates(prev => ({ ...prev, admissionTrends: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/doctor-admission-trend?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM, YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.day ||
					x?.week ||
					x?.year ||
					x?.hour,
				count: parseInt(x?.count, 10),
			}));

			setAdmissionTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, admissionTrends: false }));
		}
	};

	const fetchChargeTrends = async range => {
		setLoadingStates(prev => ({ ...prev, dischargeTrends: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/doctor-discharge-trend?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM, YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.day ||
					x?.week ||
					x?.year ||
					x?.hour,
				count: parseInt(x?.count, 10) || 0,
			}));

			setDisChargeTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, dischargeTrends: false }));
		}
	};

	const fetchDoctorsEncounter = async range => {
		setLoadingStates(prev => ({ ...prev, doctorsEncounter: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`${analyticsAPI}/encounters-by-doctor?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = Object.entries(res?.result)

				?.sort(() => Math.random() - 0.5)
				?.map(([name, count]) => ({
					name,
					count,
				}))
				.slice(0, 40);

			setDoctorsEncounter(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, doctorsEncounter: false }));
		}
	};

	const fetchDischargeCount = async range => {
		setLoadingStates(prev => ({ ...prev, dischargeCount: true }));
		setLoadingStates(prev => ({ ...prev, overviewMetrics: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/doctor-discharge-count?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			setDischargeCount(res?.result);

			setLoadingStates(prev => ({ ...prev, overviewMetrics: false }));
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, overviewMetrics: false }));
		}
	};

	const fetchAdmissionCount = async range => {
		setLoadingStates(prev => ({ ...prev, admissionCount: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`${analyticsAPI}/doctor-admission-count?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			setAdmissionCount(res?.result);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, admissionCount: false }));
		}
	};

	const fetchInvestigationCount = async range => {
		setLoadingStates(prev => ({ ...prev, investigationCount: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`${analyticsAPI}/investigation-count?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			setInvestigationCount(res?.result);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationCount: false }));
		}
	};

	const fetchEncountersCount = async range => {
		setLoadingStates(prev => ({ ...prev, encountersCount: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`${analyticsAPI}/encounters-count?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			setEncountersCount(res?.result);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, encountersCount: false }));
		}
	};

	const fetchConsultationTrends = async range => {
		setLoadingStates(prev => ({ ...prev, consultationTrends: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`analytics/appointment-consultation-type-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result;

			const formatedData = apiResponse?.map(item => ({
				date:
					item.day ||
					item.week ||
					(dateFilter == 'past-three-years' && moment(item?.month).format('MMM,YY')) ||
					(item.month && moment(item?.month).format('MMMM')) ||
					item.date ||
					item.year ||
					item?.hour,
				total: parseInt(item?.totalCount),
				initial: parseInt(item?.initialCount),
				follow_Up: parseInt(item?.followUpCount),
				review: parseInt(item?.reviewCount),
			}));
			setConsultationTrends(formatedData);
		} catch (error) {
			console.error('Failed to fetch consultation trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, consultationTrends: false }));
		}
	};

	const fetchTopBottomDoctors = async range => {
		setLoadingStates(prev => ({ ...prev, topBottomDoctors: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`analytics/procedure-doctors?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);

			const apiResponseTop = res?.top10?.map(x => ({
				name: x?.username,
				count: parseInt(x?.count, 10),
			}));

			const apiResponseBottom = res?.bottom10?.map(x => ({
				name: x?.username,
				count: parseInt(x?.count, 10),
			}));

			setTopDoctors(apiResponseTop);
			setBottomDoctors(apiResponseBottom);
		} catch (error) {
			console.error('Failed to fetch top/bottom doctors:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, topBottomDoctors: false }));
		}
	};

	const fetchDepartmentLoads = async range => {
		setLoadingStates(prev => ({ ...prev, departmentLoads: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(
				`analytics/appointment-department-counts?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);

			const apiResponse = res?.result?.map(x => ({
				name: x?.departmentName,
				value: parseInt(x?.count, 10),
			}));

			setDepartmentLoads(apiResponse);
		} catch (error) {
			console.error('Failed to fetch department loads:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, departmentLoads: false }));
		}
	};

	const fetchProcedureTrends = async range => {
		setLoadingStates(prev => ({ ...prev, procedureTrends: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`analytics/procedure-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);

			const apiResponse = res?.result?.map(x => ({
				name: x?.date || x?.day || x?.week || x?.month || x?.year,
				value: parseInt(x?.count, 10) || 0,
			}));

			setProcedureTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch procedure trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, procedureTrends: false }));
		}
	};

	const fetchTopBottomProcedures = async range => {
		setLoadingStates(prev => ({ ...prev, topBottomProcedures: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`analytics/procedure-type?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);

			const apiResponse = res?.top10?.map(x => ({
				name: x?.name?.trim() || 'Unnamed Procedure',
				value: parseInt(x?.count, 10) || 0,
			}));

			setTopBottomProcedures(apiResponse);
		} catch (error) {
			console.error('Failed to fetch top/bottom procedures:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, topBottomProcedures: false }));
		}
	};

	const fetchTopAndBottom5 = async range => {
		setLoadingStates(prev => ({ ...prev, staffRanking: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`analytics/appointment-doctors?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponseTop = res?.result?.map(x => ({
				name: x?.username ?? 'Unknown',
				count: parseInt(x?.count, 10),
			}));

			const apiResponseBottom = res?.result?.map(x => ({
				name: x?.username ?? 'Unknown',
				count: parseInt(x?.count, 10),
			}));
			setStaffRankingTop(apiResponseTop);
			setStaffRankingBottom(apiResponseBottom);
		} catch (error) {
			console.error('Failed to fetch staff rankings:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, staffRanking: false }));
		}
	};

	// Initial data load
	useEffect(() => {
		fetchDoctorAdmission(timeRanges.doctorAdmission);
		fetchAdmissionTrends(timeRanges.admissionTrends);
		fetchChargeTrends(timeRanges.dischargeTrends);
		fetchDoctorsEncounter(timeRanges.doctorsEncounter);
		fetchDischargeCount(timeRanges.dischargeCount);
		fetchAdmissionCount(timeRanges.admissionCount);
		fetchInvestigationCount(timeRanges.investigationCount);
		fetchEncountersCount(timeRanges.encountersCount);
		fetchInvestigationByDoctor(timeRanges.investigationByDoctor);
		fetchInvestigationByHour(timeRanges.investigationByHour);
		investigationByAdmission(timeRanges.investigationAdmission);

		fetchTopAndBottom5(timeRanges.topDoctorsByConsultation);
		fetchConsultationTrends(timeRanges.consultationTrends);
		fetchTopBottomDoctors(timeRanges.topBottomDoctors);
		fetchDepartmentLoads(timeRanges.departmentLoads);
		fetchProcedureTrends(timeRanges.procedureTrends);
		fetchTopBottomProcedures(timeRanges.topBottomProcedures);
	}, []);

	// Handle time range changes
	const handleTimeRangeChange = (range, chartId) => {
		setTimeRanges(prev => ({ ...prev, [chartId]: range }));

		switch (chartId) {
			case 'doctorAdmission':
				fetchDoctorAdmission(range);
				break;
			case 'doctorsEncounter':
				fetchDoctorsEncounter(range);
				break;
			case 'metrics':
				fetchDischargeCount(range);
				fetchAdmissionCount(range);
				fetchInvestigationCount(range);
				fetchEncountersCount(range);
				break;
			case 'admissionTrends':
				fetchAdmissionTrends(range);
				break;
			case 'investigationByDoctor':
				fetchInvestigationByDoctor(range);
				break;
			case 'dischargeTrends':
				fetchChargeTrends(range);
				break;
			case 'topDoctorsByConsultation':
				fetchTopAndBottom5(range);
				break;
			case 'consultationTrends':
				fetchConsultationTrends(range);
				break;
			case 'topBottomDoctors':
				fetchTopBottomDoctors(range);
				break;
			case 'departmentLoads':
				fetchDepartmentLoads(range);
				break;
			case 'procedureTrends':
				fetchProcedureTrends(range);
				break;
			case 'topBottomProcedures':
				fetchTopBottomProcedures(range);
				break;
			default:
				break;
		}
	};

	const renderCustomLabelAlt = ({ x, y, value, fill }) => {
		return (
			<text x={x} y={y} dy={-6} textAnchor="middle" fill={fill || '#333'} fontSize={12}>
				{value?.toLocaleString()}
			</text>
		);
	};

	const formatBarLabel = ({ x, y, value, width }) => (
		<text x={x + width / 2} y={y - 6} textAnchor="middle" fill="#333" fontSize={12}>
			{value?.toLocaleString()}
		</text>
	);

	const renderReport = () => {
		switch (activeTab) {
			case 'doctor':
				return (
					<div className="element-">
						{/* Overview Metrics */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Key Performance Indicators</h6>
										<TimeRangeDropdown value={timeRanges?.metrics} onChange={handleTimeRangeChange} chartId="metrics" />
									</div>
									<p className="chart-description mb-3 p-2 card">
										Summary metrics showing overall clinic activity and doctor engagement levels.
									</p>
									{loadingStates.overviewMetrics ? (
										<TableLoading />
									) : (
										<div className="element-box">
											<div className="row">
												<div className="col-md-2 col-sm-4 col-lg-3">
													<div className="value text-primary" style={{ fontSize: '25px' }}>
														{dischargeCount?.toLocaleString() || 0}
													</div>
													<div className="label">Doctors Discharge Count</div>
												</div>
												<div className="col-md-2 col-sm-4 col-lg-3">
													<div className="value text-success" style={{ fontSize: '25px' }}>
														{admissionCount?.toLocaleString() || 0}
													</div>
													<div className="label"> Doctors Admission Count</div>
												</div>
												<div className="col-md-2 col-sm-4 col-lg-3">
													<div className="value text-warning" style={{ fontSize: '25px' }}>
														{investigationCount?.toLocaleString() || 0}
													</div>
													<div className="label">Doctors Investigation Count</div>
												</div>
												<div className="col-md-2 col-sm-4 col-lg-3">
													<div className="value text-info" style={{ fontSize: '25px' }}>
														{encountersCount?.toLocaleString() || 0}
													</div>
													<div className="label">Doctors Encounter Count</div>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>

						{/* doctor admission */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor Admission Overview</h6>
										<TimeRangeDropdown value={timeRanges.doctorAdmission} onChange={handleTimeRangeChange} chartId="doctorAdmission" />
									</div>
									<p className="chart-description card p-2">
										Comprehensive analytics on doctor productivity, patient loads, and clinical operations.
									</p>
									<div className="element-box">
										{loadingStates.doctorAdmission ? (
											<TableLoading />
										) : doctorAdmission.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<AreaChart data={doctorAdmission} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														<Legend />
														<Area
															type="monotone"
															dataKey="count"
															stroke="#0088FE"
															fill="#0088FE"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="count"
																content={renderCustomLabelAlt}
																position="top"
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
													</AreaChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/*doctor admission trend  */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor Admission Trends</h6>
										<TimeRangeDropdown value={timeRanges?.admissionTrends} onChange={handleTimeRangeChange} chartId="admissionTrends" />
									</div>
									<p className="chart-description card p-2">
										Comprehensive analytics on doctor productivity, patient loads, and clinical operations.
									</p>
									<div className="element-box">
										{loadingStates?.admissionTrends ? (
											<TableLoading />
										) : admissionTrends.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<BarChart data={admissionTrends} margin={{ top: 20, right: 20, left: 20, bottom: 45 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={timeRanges.admissionTrends === 'pastQuarter' ? 2 : 0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														<Legend wrapperStyle={{ marginBottom: '-50px' }} />
														<Bar dataKey="count">
															{admissionTrends.map((entry, index) => (
																<Cell key={`cell-eff-${index}`} fill={COLORS[(index + 2) % COLORS.length]} />
															))}
															<LabelList
																dataKey="count"
																content={formatBarLabel}
																position="top"
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Bar>
													</BarChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/*doctor discharge trend  */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor Discharge Trends</h6>
										<TimeRangeDropdown value={timeRanges?.dischargeTrends} onChange={handleTimeRangeChange} chartId="dischargeTrends" />
									</div>
									<p className="chart-description card p-2">
										This charts shows the cumulative discharge trends over time, providing insights into patient flow and discharge rates.
									</p>
									<div className="element-box">
										{loadingStates.dischargeTrends ? (
											<TableLoading />
										) : dischargeTrends.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<LineChart data={dischargeTrends} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={timeRanges.dischargeTrends === 'pastQuarter' ? 2 : 0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														<Legend wrapperStyle={{ marginBottom: '-50px' }} />
														<Line type="monotone" dataKey="count" stroke="#22BB33" strokeWidth={2} dot={{ r: 4 }} activeDot={{ r: 6 }}>
															<LabelList
																dataKey="count"
																content={renderCustomLabelAlt}
																position="top"
																style={{ fontSize: '10px', fill: '#333' }}
															/>
														</Line>
													</LineChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/*doctor encounters  */}
						<div className="row">
							<div className="col-sm-12 ">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor's Encounter Trends</h6>
										<TimeRangeDropdown value={timeRanges?.doctorsEncounter} onChange={handleTimeRangeChange} chartId="doctorsEncounter" />
									</div>
									<p className="chart-description card p-2">
										This charts shows the number of encounters per doctor over the selected time period, helping to identify workload
										distribution and patient interaction levels.
									</p>
									<div className="element-box">
										{loadingStates.doctorsEncounter ? (
											<TableLoading />
										) : doctorsEncounter.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<AreaChart data={doctorsEncounter} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														<Legend wrapperStyle={{ marginBottom: '-45px' }} />
														<Area
															type="monotone"
															dataKey="count"
															stroke="#8884d8"
															fill="#8884d8"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="count"
																content={renderCustomLabelAlt}
																position="top"
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
													</AreaChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/* Consultation Trends */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Consultation Volume Trends</h6>
										<TimeRangeDropdown
											value={timeRanges.consultationTrends}
											onChange={handleTimeRangeChange}
											chartId="consultationTrends"
										/>
									</div>
									<p className="chart-description mb-3 p-2 card">
										Tracking consultation patterns over time to identify peak periods and seasonal variations.
									</p>
									<div className="element-box">
										{loadingStates?.consultationTrends ? (
											<TableLoading />
										) : consultationTrends?.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<AreaChart data={consultationTrends} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'date'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={timeRanges?.consultationTrends == 'pastQuarter' ? 2 : 0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip content={<CustomTooltipAlt />} />
														<Legend wrapperStyle={{ marginBottom: '-50px' }} />
														<Area
															type="monotone"
															dataKey="initial"
															stroke="#8884d8"
															fill="#8884d8"
															fillOpacity={0.2}
															name="initial"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="initial"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
														<Area
															type="monotone"
															dataKey="follow_Up"
															stroke="#82ca9d"
															fill="#82ca9d"
															fillOpacity={0.2}
															name="Follow-up"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="follow_up"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
														<Area
															type="monotone"
															dataKey="review"
															stroke="red"
															fill="red"
															fillOpacity={0.2}
															name="review"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="review"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
														{/* <Area
															type="monotone"
															dataKey="others"
															stroke="blue"
															fill="blue"
															fillOpacity={0.2}
															name="others"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="others"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area> */}
													</AreaChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/* Top/Bottom Doctors */}
						<div className="row">
							<div className="row col-12">
								<div className="col-sm-12 col-lg-">
									<div className="element-wrapper">
										<h6 className="element-header">Staff Appointment Ranking by Consultations</h6>
										<h6>Top (Highest)</h6>
										<div className="d-flex justify-content-end mb-5 w-100">
											<div className="d-flex justify-content-end w-100">
												<div>
													<div
														style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
														onClick={() => setModal(true)}
														className="form-control form-control-sm text-white bg-primary rounded"
													>
														View All
													</div>
												</div>
												&nbsp;
												<TimeRangeDropdown
													value={timeRanges.topDoctorsByConsultation}
													onChange={handleTimeRangeChange}
													chartId="topDoctorsByConsultation"
												/>
											</div>
											{/* <TimeRangeDropdown value={timeRanges.staffRanking} onChange={handleTimeRangeChange} chartId="staffRanking" /> */}
										</div>
										<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
											This chart ranks Doctors by their total consultations over the selected time period, highlighting top performers.
										</p>
										<div className="card">
											{loadingStates.staffRanking ? (
												<TableLoading />
											) : staffRankingTop?.length > 0 ? (
												<div style={{ width: '100%', height: 400 }}>
													<ResponsiveContainer width="100%" height={400}>
														<BarChart data={staffRankingTop?.slice(0, 10)} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
															<CartesianGrid strokeDasharray="5 5" />
															<XAxis
																dataKey={'name'}
																angle={-45}
																textAnchor="end"
																fontSize={12}
																interval={0}
																tickFormatter={value => {
																	const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																	const capitalized = truncated
																		.toLowerCase()
																		.split(' ')
																		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																		.join(' ');
																	return capitalized;
																}}
															/>
															<YAxis domain={[0, 'auto']} />
															<Tooltip
																formatter={value => Number(value).toLocaleString()}
																labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
															/>
															<Legend wrapperStyle={{ marginBottom: '-45px' }} />

															<Bar dataKey="count">
																{staffRankingTop.map((entry, index) => (
																	<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																))}
																<LabelList dataKey="count" position="top" content={formatBarLabel} />
															</Bar>
														</BarChart>
													</ResponsiveContainer>
												</div>
											) : (
												<div className="text-center fs-bold">No Record Found!</div>
											)}
										</div>
									</div>
								</div>

								<div className="col-sm-12 col-lg-">
									<div className="element-wrapper mt-4">
										{/* <h6 className="element-header"> </h6> */}
										<h6>Bottom (Lowest)</h6>
										<div className="d-flex justify-content-end w-100">
											<div className="d-flex justify-content-end w-100">
												<div>
													<div
														style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
														onClick={() => setModal(true)}
														className="form-control form-control-sm text-white bg-primary rounded"
													>
														View All
													</div>
												</div>
												&nbsp;
												<TimeRangeDropdown
													value={timeRanges.topDoctorsByConsultation}
													onChange={handleTimeRangeChange}
													chartId="topDoctorsByConsultation"
												/>
											</div>
										</div>
										<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
											This chart shows staff with the lowest performing doctors by consultations, helping identify areas for improvement.
										</p>
										<div className="card">
											{loadingStates.staffRanking ? (
												<TableLoading />
											) : staffRankingBottom?.length > 0 ? (
												<div style={{ width: '100%', height: 400 }}>
													<ResponsiveContainer width="100%" height={400}>
														<BarChart data={staffRankingBottom?.slice(-10)} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
															<CartesianGrid strokeDasharray="5 5" />
															<XAxis
																dataKey={'name'}
																angle={-45}
																textAnchor="end"
																fontSize={12}
																interval={0}
																tickFormatter={value => {
																	const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																	const capitalized = truncated
																		.toLowerCase()
																		.split(' ')
																		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																		.join(' ');
																	return capitalized;
																}}
															/>
															<YAxis domain={[0, 'auto']} />
															<Tooltip
																formatter={value => Number(value).toLocaleString()}
																labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
															/>
															<Legend wrapperStyle={{ marginBottom: '-45px' }} />
															<Bar dataKey="count">
																{staffRankingBottom.map((entry, index) => (
																	<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																))}
																<LabelList dataKey="count" position="top" content={formatBarLabel} />
															</Bar>
														</BarChart>
													</ResponsiveContainer>
												</div>
											) : (
												<div className="text-center fs-bold">No Record Found!</div>
											)}
										</div>
									</div>
									<SlidingPane isOpen={modal}>
										<div className=" content-box">
											<div className=" d-flex justify-content-end w-100">
												<button className="btn btn-danger float-end" onClick={() => setModal(false)}>
													&times;
												</button>
											</div>

											<div className=" d-flex justify-content-end mt-5 t-5 align-items-center">
												<TimeRangeDropdown
													value={timeRanges.topDoctorsByConsultation}
													onChange={handleTimeRangeChange}
													chartId="topDoctorsByConsultation"
												/>
											</div>
											<div className="row  w-100 " style={{ paddingLeft: '50px', paddingRight: '50px' }}>
												<div className="col-sm-12">
													<div className="element-wrapper">
														<h6 className="element-header">Staff Appointment Ranking by Consultations</h6>

														<p className="chart-description card p-2 " style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
															High-level metrics showing overall metrics of reading over time.
														</p>
														<div className="element-box">
															{/* <TableLoading /> */}

															<Row gutter={16}>
																<Col span={8}>
																	<Card>
																		<Statistic title="Total" value={staffRankingBottom?.length} suffix="" />
																		<small className="text-muted">Total Clinical Tasks</small>
																	</Card>
																</Col>
																{/* <Col span={8}>
														<Card>
															<Statistic
																title="Total Revenue"
																value={transSummary?.totalRevenueFormatted} suffix=""
															/>

															<small className="text-muted">Cumulative Revenue From --- to --</small>
														</Card>
													</Col>
													<Col span={8}>
														<Card>
															<Statistic
																title="Total Transactions"
																value={transSummary?.totalTransactions} suffix=""
															/>
															<Statistic
																					title="Survey Coverage Rate"
																					value={coverageRate > 0 ? (coverageRate).toFixed(1) : 0}
																					suffix=""
																				/>
															<small className="text-muted">Cumulative Transactions From --- to --</small>
														</Card>
													</Col> */}
																{/* <Col span={6}>
																		<Card>
																			<Statistic title="Lowest Scoring Area" value={0} suffix="/3" />
																			<small className="text-muted">Needs attention</small>
																		</Card>
																	</Col> */}
															</Row>
														</div>
													</div>
												</div>
											</div>

											<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
												<p className="chart-description card p-2">
													This chart Ranks doctors performance by consultations, helping identify areas for improvement.
												</p>
											</div>

											<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
												<div className=" card w-100 ">
													<div className="row">
														<div className="col-md-12 mb-4">
															<div className="card h-100">
																<div className="card-body">
																	{loadingStates.staffRanking ? (
																		<TableLoading />
																	) : staffRankingBottom?.length > 0 ? (
																		<div style={{ width: '100%', height: 'auto' }}>
																			{staffRankingBottom?.length > 45 ? (
																				<ResponsiveContainer width="100%" height={staffRankingBottom?.length * 40}>
																					<BarChart
																						data={staffRankingBottom}
																						layout="vertical"
																						margin={{ top: 20, right: 30, left: 80, bottom: 20 }}
																					>
																						<CartesianGrid strokeDasharray="5 5" />

																						{/* Categories on Y axis */}
																						<YAxis
																							type="category"
																							dataKey="name"
																							tick={{ fontSize: 12 }}
																							width={120}
																							tickFormatter={value => {
																								const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																								const capitalized = truncated
																									.toLowerCase()
																									.split(' ')
																									.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																									.join(' ');
																								return capitalized;
																							}}
																						/>

																						{/* Values on X axis */}
																						<XAxis type="number" domain={[0, 'auto']} />

																						<Tooltip
																							formatter={value => Number(value).toLocaleString()}
																							labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
																						/>
																						<Legend />

																						<Bar dataKey="count">
																							{staffRankingBottom.map((entry, index) => (
																								<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																							))}
																							<LabelList dataKey="count" position="right" content={formatBarLabel} />
																						</Bar>
																					</BarChart>
																				</ResponsiveContainer>
																			) : (
																				<ResponsiveContainer width="100%" height={400}>
																					<BarChart data={staffRankingBottom} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
																						<CartesianGrid strokeDasharray="5 5" />
																						<XAxis
																							dataKey={'name'}
																							angle={-45}
																							textAnchor="end"
																							fontSize={12}
																							interval={0}
																							tickFormatter={value => {
																								const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																								const capitalized = truncated
																									.toLowerCase()
																									.split(' ')
																									.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																									.join(' ');
																								return capitalized;
																							}}
																						/>
																						<YAxis domain={[0, 'auto']} />
																						<Tooltip
																							formatter={value => Number(value).toLocaleString()}
																							labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
																						/>
																						<Legend wrapperStyle={{ marginBottom: '-45px' }} />
																						<Bar dataKey="count">
																							{staffRankingBottom.map((entry, index) => (
																								<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																							))}
																							<LabelList dataKey="count" position="top" content={formatBarLabel} />
																						</Bar>
																					</BarChart>
																				</ResponsiveContainer>
																			)}
																		</div>
																	) : (
																		<div className="text-center fs-bold">No Record Found!</div>
																	)}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</SlidingPane>
								</div>
							</div>
						</div>
					</div>
				);
			case 'antenatal':
				return <AntenatalOverview />;
			// case 'immunization':
			// 	return <ImmunizationOverview />;
			default:
				return <div>Select a report type</div>;
		}
	};

	const COLORSe = {
		appointment: '#8884d8',
		registration: '#82ca9d',
	};

	// Custom tooltip
	const CustomTooltip = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			return (
				<div className="custom-tooltip bg-white p-3 shadow rounded">
					<p className="font-weight-bold mb-2 text-capitalize">{payload[0]?.payload?.name || label}</p>
					{payload.map((entry, index) => (
						<p key={`item-${index}`} style={{ color: entry.color || '#000' }}>
							{`${entry.name}: ${entry.value}`}
							{entry.dataKey === 'avgTime' && ' mins'}
							{entry.dataKey === 'satisfaction' && '%'}
						</p>
					))}
					{payload[0]?.payload?.specialty && <p className="text-muted">Specialty: {payload[0].payload.specialty}</p>}
				</div>
			);
		}
		return null;
	};

	const CustomTooltipAlt = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload; // the whole row object
			return (
				<div className="custom-tooltip" style={{ background: '#fff', border: '1px solid #ccc', padding: '8px' }}>
					<p>
						<strong>Date:</strong> {label}
					</p>
					<p>
						<strong>Initial:</strong> {data.initial?.toLocaleString()}
					</p>
					<p>
						<strong>Follow-up:</strong> {data.follow_Up?.toLocaleString()}
					</p>
					<p>
						<strong>Review:</strong> {data.review?.toLocaleString()}
					</p>
					<p>
						<strong>Total:</strong> {data.total?.toLocaleString()}
					</p>{' '}
					{/* 👈 shows your total */}
				</div>
			);
		}
		return null;
	};

	return (
		<div className="content-i">
			<div className="content-box">
				<div className="element-wrapper">
					<h6 className="element-header">Doctor's Overview</h6>
					<div className="element-box">
						<div className="row mb-4">
							<div className="col-sm-8">
								<div className="btn-group" role="group">
									<button className={`btn btn-light ${activeTab === 'doctor' ? 'active' : ''}`} onClick={() => setActiveTab('doctor')}>
										Doctor
									</button>
									<button
										className={`btn btn-light ${activeTab === 'antenatal' ? 'active' : ''}`}
										onClick={() => setActiveTab('antenatal')}
									>
										Antenatal
									</button>
									{/* <button
											className={`btn btn-light ${activeTab === 'immunization' ? 'active' : ''}`}
											onClick={() => setActiveTab('immunization')}
										>
											Immunization
										</button> */}
								</div>
							</div>
						</div>
						<div className="col-sm-12"></div>
						{renderReport()}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DoctorOverviewModal;
